/* SIGNAL — l'assistente dentro il negozio del cliente.
 *
 * Gira nel browser di chi sta comprando. Tre cose che NON fa, e non deve fare:
 * - non conosce nessun segreto: il file è pubblico come tutto il tema;
 * - non decide il negozio: lo dichiara, e il server lo verifica e risponde con un gettone
 *   firmato. Da lì in poi il negozio lo stabilisce il gettone, non questa pagina;
 * - non aggiunge al carrello un PRODOTTO: aggiunge una VARIANTE scelta dal visitatore.
 */
(function () {
  "use strict";

  /* UNA SOLA ISTANZA, ma solo quando ce n'è davvero una.
     Prima la bandierina si alzava PRIMA di provare ad avviarsi: se l'avvio falliva — rete,
     assistente non ancora configurato, gettone scaduto — nessun secondo tentativo poteva
     più partire, nemmeno quando il tema ricarica una sezione. La bandierina si alza
     quando il riquadro esiste davvero. */
  function giaCostruito() { return !!document.querySelector(".signal-w"); }

  var stato = { gettone: null, nome: "Assistente", aperto: false, occupato: false, prodotto: null, dominio: null, negozio: null, radice: "/",
    saluto: null, suggerimenti: [], corrente: null, avviso: null, avvisoPiu: null, aperturaFatta: false,
    rigaDomanda: null, paginaBloccata: false, tornaA: 0, apertura: "chat", fuocoPrima: null, riferimento: null, carrelloFatto: false };
  var avvioInCorso = false;

  /* LA CONVERSAZIONE DEVE SOPRAVVIVERE AL CAMBIO PAGINA.
     Prima a ogni pagina si chiedeva un gettone nuovo, quindi una sessione nuova: chi
     passava dalla collezione al prodotto ricominciava da capo, e l'assistente richiedeva
     la taglia che gli era appena stata detta. Il gettone si tiene in `sessionStorage`,
     per NEGOZIO e con la sua scadenza; quando scade se ne prende un altro.
     `sessionStorage` e non `localStorage`: finita la visita, finita la conversazione. */
  function chiave(negozio) { return "signal.assistente." + negozio; }

  function gettoneSalvato(negozio) {
    try {
      var g = JSON.parse(sessionStorage.getItem(chiave(negozio)) || "null");
      if (!g || !g.t || !g.scade || g.scade < Date.now()) return null;
      return g;
    } catch (e) { return null; }
  }

  function salvaGettone(negozio, gettone, nome) {
    // Dura meno di quanto dice il server: meglio rinnovarlo un po' prima che scoprirlo scaduto.
    try { sessionStorage.setItem(chiave(negozio), JSON.stringify({ t: gettone, nome: nome, scade: Date.now() + 11 * 3600 * 1000 })); }
    catch (e) { /* navigazione privata: si vive senza, la conversazione ricomincia */ }
  }

  function scordaGettone(negozio) {
    try { sessionStorage.removeItem(chiave(negozio)); } catch (e) { /* niente */ }
  }

  function radice(el) {
    var r = (el && el.getAttribute("data-signal-radice")) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return r.charAt(r.length - 1) === "/" ? r : r + "/";
  }

  function trovaConfig() {
    var el = document.getElementById("signal-assistente") || document.querySelector("[data-signal-dominio]");
    if (!el) return null;
    return {
      el: el,
      dominio: el.getAttribute("data-signal-dominio"),
      negozio: el.getAttribute("data-signal-negozio"),
      radice: radice(el),
      prodotto: el.getAttribute("data-signal-prodotto") || null,
      posizione: el.getAttribute("data-signal-posizione") || "destra",
      etichetta: el.getAttribute("data-signal-etichetta") || "Ti serve una mano?",
    };
  }

  function base() { return "https://" + stato.dominio + "/api/assistente/pubblico"; }

  function elemento(tag, classe, testo) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (testo != null) e.textContent = testo;   // textContent e non innerHTML: niente HTML da fuori
    return e;
  }

  /* ── il riquadro ─────────────────────────────────────────────────────────── */

  var nodi = {};

  function costruisci(cfg) {
    /* DUE MODI DI COMPARIRE, e lo decide SIGNAL.
       «chat»: la linguetta in basso, sempre li'.
       «modale»: NESSUNA linguetta, e il riquadro si apre a tendina sopra il sito, come il
       carrello. Serve ai negozi che in basso a destra hanno gia' WhatsApp o Inbox di
       Shopify: due bolle che si accavallano non le vuole nessuno. Li' si apre solo dai
       blocchi messi nella pagina. */
    var modale = stato.apertura === "modale";
    var root = elemento("div", "signal-w signal-w--" + cfg.posizione + (modale ? " signal-w--modale" : ""));

    var bolla = elemento("button", "signal-w-bolla");
    bolla.type = "button";
    bolla.setAttribute("aria-haspopup", "dialog");
    bolla.appendChild(elemento("span", null, cfg.etichetta));
    // In modale la linguetta non esiste proprio: non nascosta con la CSS — assente.
    // Una linguetta invisibile ma presente resta raggiungibile col tasto Tab, e chi
    // naviga da tastiera troverebbe un bottone che non si vede da nessuna parte.
    if (modale) bolla.hidden = true;

    // Il velo dietro la tendina: chiude toccando fuori, come ogni pannello di Shopify.
    var velo = elemento("div", "signal-w-velo");
    velo.hidden = true;

    var pannello = elemento("div", "signal-w-pan");
    pannello.setAttribute("role", "dialog");
    pannello.setAttribute("aria-modal", modale ? "true" : "false");
    pannello.hidden = true;

    var testa = elemento("div", "signal-w-testa");
    var titolo = elemento("strong", "signal-w-nome", stato.nome);
    var chiudi = elemento("button", "signal-w-chiudi", "✕");
    chiudi.type = "button";
    chiudi.setAttribute("aria-label", "Chiudi");
    testa.appendChild(titolo); testa.appendChild(chiudi);

    /* La riga dell'avviso: che risponde una macchina va detto subito, non in fondo
       in grigio chiaro. */
    var avviso = elemento("div", "signal-w-avviso");
    avviso.appendChild(elemento("span", "signal-w-avviso-t", stato.avviso || "Utilizzo l'intelligenza artificiale e continuo a migliorare ogni giorno."));
    /* «MAGGIORI INFORMAZIONI», come nella reference. La risposta NON passa dal modello:
       e' una dichiarazione su come funziona SIGNAL, e farla generare vorrebbe dire
       lasciare che venga scritta ogni volta un po' diversa — su questo argomento e'
       esattamente la cosa da non fare. Testo fisso, dal server, subito. */
    if (stato.avvisoPiu && stato.avvisoPiu.tasto) {
      var piu = elemento("button", "signal-w-piu", stato.avvisoPiu.tasto);
      piu.type = "button";
      piu.addEventListener("click", function () { spiegaAi(); });
      avviso.appendChild(piu);
    }

    var lista = elemento("div", "signal-w-lista");
    lista.setAttribute("aria-live", "polite");

    var form = elemento("form", "signal-w-form");
    var campo = elemento("input", "signal-w-campo");
    campo.type = "text";
    campo.placeholder = "Scrivi la tua domanda…";
    campo.setAttribute("aria-label", "La tua domanda");
    var invia = elemento("button", "signal-w-invia", "Invia");
    invia.type = "submit";
    form.appendChild(campo); form.appendChild(invia);

    /* Sotto il campo: la riga sulla privacy. Sta li' perche' li' si scrive. */
    var piede = elemento("div", "signal-w-piede");
    piede.appendChild(elemento("span", null, "Proseguendo confermi di aver letto l'"));
    var pp = elemento("a", "signal-w-pp", "Informativa sulla privacy");
    pp.href = stato.radice.replace(/\/$/, "") + "/policies/privacy-policy";
    pp.target = "_blank"; pp.rel = "noopener";
    piede.appendChild(pp);

    pannello.appendChild(testa); pannello.appendChild(avviso);
    pannello.appendChild(lista); pannello.appendChild(form); pannello.appendChild(piede);
    if (!modale) root.appendChild(bolla);
    root.appendChild(velo);
    root.appendChild(pannello);
    document.body.appendChild(root);

    nodi = { root: root, bolla: bolla, velo: velo, pannello: pannello, titolo: titolo, lista: lista, form: form, campo: campo, invia: invia, modale: modale };

    apertura();

    bolla.addEventListener("click", function () { apri(true); });
    chiudi.addEventListener("click", function () { apri(false); });
    velo.addEventListener("click", function () { apri(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && stato.aperto) apri(false);
      else fuocoDentro(e);
    });
    form.addEventListener("submit", function (e) { e.preventDefault(); chiedi(campo.value); });
    // Il blocco in linea apre lo stesso riquadro: nessun secondo pannello.
    document.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-signal-apri]");
      if (b) { e.preventDefault(); apri(true); }
    });
  }

  /* ── L'APERTURA ───────────────────────────────────────────────────────────
     Il riquadro si apriva vuoto: un campo di testo e un cursore, cioe' «indovina
     tu cosa so fare». Adesso si presenta: una frase, il capo che il visitatore ha
     davanti se e' su una scheda, e delle domande da TOCCARE invece che da scrivere.
     Le domande vengono dal server, non da qui: sono quelle a cui si sa rispondere. */
  function apertura() {
    if (stato.aperturaFatta) return;
    stato.aperturaFatta = true;

    if (stato.saluto) scrivi("assistente", stato.saluto);

    if (stato.corrente) {
      var box = elemento("div", "signal-p-lista signal-p-lista--uno");
      box.appendChild(scheda({
        titolo: stato.corrente.titolo, url: stato.corrente.url, immagine: stato.corrente.immagine,
        prezzoDa: stato.corrente.prezzoDa, valuta: stato.corrente.valuta, varianti: [],
      }));
      nodi.lista.appendChild(box);
    }

    if (stato.suggerimenti && stato.suggerimenti.length) {
      var chips = elemento("div", "signal-w-chips");
      stato.suggerimenti.forEach(function (t) {
        var b = elemento("button", "signal-w-chip", t);
        b.type = "button";
        b.addEventListener("click", function () { chiedi(t); });
        chips.appendChild(b);
      });
      nodi.lista.appendChild(chips);
    }
  }

  /* SI LEGGE DALL'INIZIO, NON DALLA FINE.
     Prima, finita la risposta, si scorreva in fondo: chi aveva chiesto qualcosa si
     trovava davanti l'ULTIMA proposta e doveva risalire a mano per leggere la frase e
     vedere la prima. Adesso si porta in cima la riga della domanda: la risposta comincia
     subito sotto e si legge scendendo, come una pagina.
     Se non c'e' abbastanza contenuto sotto, si scende quanto si puo' — ma in quel caso
     e' tutto gia' visibile, quindi non c'e' niente da risalire. */
  function portaInAlto(nodo) {
    if (!nodo || !nodi.lista) return;
    var y = nodo.getBoundingClientRect().top - nodi.lista.getBoundingClientRect().top + nodi.lista.scrollTop;
    var massimo = nodi.lista.scrollHeight - nodi.lista.clientHeight;
    nodi.lista.scrollTop = Math.max(0, Math.min(y - 8, massimo));
  }

  /* DA TELEFONO, LO SCORRIMENTO RESTA DENTRO LA CHAT.
     Col riquadro aperto, il dito che scorreva i messaggi faceva scorrere il SITO dietro:
     si vedeva la pagina muoversi e la conversazione stare ferma. La pagina si blocca
     finche' il riquadro e' aperto, e si rimette esattamente dove stava alla chiusura —
     un blocco che perde la posizione e' un guasto peggiore di quello che risolve.
     Solo da telefono: su desktop il riquadro e' un angolo della pagina, non un foglio,
     e bloccare tutto il sito sarebbe un sopruso. */
  function bloccaPagina(sì) {
    var b = document.body;
    if (!b) return;
    if (sì) {
      if (stato.paginaBloccata) return;
      /* In modale la tendina copre il sito a qualunque larghezza: la pagina dietro deve
         stare ferma comunque. Nel modo chat il riquadro e' un angolo, e bloccare tutto
         il sito da desktop sarebbe un sopruso: li' vale solo il telefono. */
      if (stato.apertura !== "modale" && !(window.matchMedia && window.matchMedia("(max-width: 480px)").matches)) return;
      stato.tornaA = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.style.top = (-stato.tornaA) + "px";
      b.classList.add("signal-pagina-ferma");
      stato.paginaBloccata = true;
    } else {
      if (!stato.paginaBloccata) return;
      b.classList.remove("signal-pagina-ferma");
      b.style.top = "";
      stato.paginaBloccata = false;
      window.scrollTo(0, stato.tornaA);
    }
  }

  function apri(sì) {
    stato.aperto = sì;
    nodi.pannello.hidden = !sì;
    nodi.velo.hidden = !sì || !nodi.modale;
    nodi.root.classList.toggle("signal-w--aperto", sì);
    nodi.bolla.setAttribute("aria-expanded", sì ? "true" : "false");
    bloccaPagina(sì);
    if (sì) {
      /* CHI APRE DEVE RITROVARE IL SUO POSTO. In modale il riquadro copre il sito: se
         alla chiusura il fuoco tornasse in cima alla pagina, chi naviga da tastiera
         perderebbe il punto in cui stava. Si tiene da parte e si rimette. */
      stato.fuocoPrima = document.activeElement;
      nodi.campo.focus();
    } else if (stato.fuocoPrima && stato.fuocoPrima.focus) {
      try { stato.fuocoPrima.focus(); } catch (e) { /* elemento sparito nel frattempo */ }
      stato.fuocoPrima = null;
    }
  }

  /* IL FUOCO RESTA DENTRO LA TENDINA. Un pannello che copre il sito e dal quale il Tab
     porta sui link di sotto — invisibili, sotto il velo — è una trappola per chi non usa
     il mouse. Vale solo in modale: nel modo chat il riquadro è un angolo della pagina e
     il resto del sito è lì, usabile. */
  function fuocoDentro(e) {
    if (e.key !== "Tab" || !stato.aperto || !nodi.modale) return;
    var dentro = nodi.pannello.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var vivi = [];
    for (var i = 0; i < dentro.length; i++) {
      var x = dentro[i];
      if (!x.hidden && x.offsetParent !== null) vivi.push(x);
    }
    if (!vivi.length) return;
    var primo = vivi[0], ultimo = vivi[vivi.length - 1];
    if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
  }

  /* LA SPIEGAZIONE SULL'INTELLIGENZA ARTIFICIALE.
     Si scrive nella conversazione come un normale scambio — la domanda e la risposta —
     ma non esce nessuna richiesta di rete: il testo arriva gia' dall'avvio. Cosi' e'
     istantaneo, e soprattutto e' SEMPRE LO STESSO. */
  function spiegaAi() {
    var a = stato.avvisoPiu;
    if (!a) return;
    if (a.domanda) stato.rigaDomanda = scrivi("visitatore", a.domanda);
    var r = elemento("div", "signal-m signal-m--assistente");
    if (a.intro) r.appendChild(elemento("p", "signal-m-t", a.intro));
    if (a.punti && a.punti.length) {
      var ul = elemento("ul", "signal-m-punti");
      for (var i = 0; i < a.punti.length; i++) ul.appendChild(elemento("li", null, a.punti[i]));
      r.appendChild(ul);
    }
    if (a.chiusura) r.appendChild(elemento("p", "signal-m-t", a.chiusura));
    nodi.lista.appendChild(r);
    // Si legge dall'inizio, come ogni altra risposta.
    portaInAlto(stato.rigaDomanda);
  }

  /* L'ATTESA SI DEVE VEDERE CHE E' VIVA.
     Prima erano tre puntini fermi, e fermi vogliono dire «finito» quanto «sto
     lavorando»: chi guardava non sapeva se aspettare o riscrivere. Tre pallini che si
     muovono dicono una cosa sola.
     Per chi ha chiesto al sistema di ridurre le animazioni restano fermi ma visibili —
     e in tutti e due i casi `role="status"` lo dice anche a chi legge con la voce, che
     un pallino che salta non lo sente. */
  function puntiniCheAspettano() {
    var r = elemento("div", "signal-m signal-m--assistente");
    var box = elemento("span", "signal-attesa");
    box.setAttribute("role", "status");
    box.setAttribute("aria-label", "Sto scrivendo");
    for (var i = 0; i < 3; i++) box.appendChild(elemento("span", "signal-attesa-p"));
    r.appendChild(box);
    nodi.lista.appendChild(r);
    nodi.lista.scrollTop = nodi.lista.scrollHeight;
    return r;
  }

  function scrivi(chi, testo) {
    var r = elemento("div", "signal-m signal-m--" + chi);
    r.appendChild(elemento("p", "signal-m-t", testo));
    nodi.lista.appendChild(r);
    nodi.lista.scrollTop = nodi.lista.scrollHeight;
    return r;
  }

  /* ── le schede prodotto, con la variante scelta da chi compra ─────────────── */

  /* LA SCHEDA, COME NELLA REFERENCE: foto, nome, prezzo. E basta.
     Prima ogni scheda portava anche un menu a tendina delle taglie e un bottone
     «Aggiungi al carrello»: dentro una colonna larga un terzo di pannello, quei due
     elementi mandavano tutto a capo e facevano scorrere la griglia di lato. Da Mango
     la scheda nella chat e' un link al prodotto — si sceglie la taglia sulla scheda
     vera, dove c'e' la guida alle taglie e le foto grandi. */
  /* QUANDO QUALCUNO APRE UNA SCHEDA PROPOSTA.
     Due cose, e nessuna delle due deve rallentare il clic: si parte e si lascia andare.
     1. lo si dice a SIGNAL — che poi verifica da solo che quel prodotto fosse davvero
        stato proposto a questa conversazione: dal browser arriva una dichiarazione,
        non un dato;
     2. si lascia un CONTRASSEGNO sul carrello di Shopify. Da li' in poi la prova non
        sta piu' nel browser ne' nei nostri contatori: sta dentro l'ordine.
     `keepalive` perche' subito dopo la pagina cambia: senza, il browser butta via la
     richiesta a meta' e il conteggio perde proprio i clic andati a buon fine. */
  function segnalaTocco(prodottoId) {
    if (!stato.gettone) return;
    var manda = function (tipo) {
      try {
        fetch(base() + "/evento?shop=" + encodeURIComponent(stato.negozio), {
          method: "POST", keepalive: true,
          headers: { "Content-Type": "application/json", "X-Signal-Gettone": stato.gettone },
          body: JSON.stringify({ prodotto: prodottoId, tipo: tipo }),
        }).catch(function () {});
      } catch (e) { /* un contatore non vale un clic */ }
    };
    manda("toccato");
    contrassegnaCarrello(function () { manda("carrello"); });
  }

  /* IL CONTRASSEGNO SUL CARRELLO. Si scrive una volta sola per pagina, e solo quando la
     conversazione e' davvero cominciata: e' l'unico filo che lega questa conversazione
     a un ordine, e senza di lui «l'assistente porta vendite?» resta senza risposta.
     Porta il riferimento opaco della sessione, MAI il gettone: quello autentica, e non
     deve finire nei dati di un ordine. */
  function contrassegnaCarrello(poi) {
    if (!stato.riferimento) return;
    if (stato.carrelloFatto) { if (poi) poi(); return; }
    stato.carrelloFatto = true;
    try {
      fetch(stato.radice.replace(/\/$/, "") + "/cart/update.js", {
        method: "POST", keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { SIGNAL: stato.riferimento } }),
      }).then(function (r) { if (r && r.ok && poi) poi(); })
        .catch(function () { stato.carrelloFatto = false; });
    } catch (e) { stato.carrelloFatto = false; }
  }

  function scheda(p) {
    var c = elemento("a", "signal-p");
    c.href = stato.radice.replace(/\/$/, "") + p.url;
    /* SOLO LE SCHEDE CHE SONO UNA PROPOSTA. La scheda in cima al riquadro e' il capo
       che il visitatore sta GIA' guardando: nasce senza identificativo, e contarla
       gonfierebbe il numero con un clic su qualcosa a cui era gia' arrivato da solo.
       Senza questo controllo partiva comunque una richiesta senza `prodotto`, che il
       server rifiutava — inutile, e nei log sembrava un tentativo di manomissione. */
    if (p.prodottoId) c.addEventListener("click", function () { segnalaTocco(p.prodottoId); });
    if (p.immagine) {
      var img = elemento("img", "signal-p-img");
      img.src = p.immagine; img.alt = ""; img.loading = "lazy";
      c.appendChild(img);
    } else {
      c.appendChild(elemento("span", "signal-p-img"));
    }
    var corpo = elemento("div", "signal-p-corpo");
    corpo.appendChild(elemento("span", "signal-p-nome", p.titolo));
    /* «ESAURITO» SI DICE SOLO SE LO SAPPIAMO.
       Prima bastava una lista di varianti vuota: `filter` su `[]` da' zero, e zero
       diventava «Esaurito». Ma una lista vuota vuol dire DUE cose diverse — «non ne ha
       nessuna comprabile» e «non me le ha mandate nessuno» — e qui si confondevano.
       Il guasto si vedeva nel posto peggiore: la scheda in cima al riquadro, quella del
       capo che il visitatore ha DAVANTI, nasce apposta con `varianti: []` perche' il
       server manda solo nome, foto e prezzo. Risultato: ogni visitatore che apriva
       l'assistente su una scheda prodotto leggeva «Esaurito» sotto il capo che stava
       guardando — in vendita. Trovato guardando il banco a 375px.
       Adesso: se non sappiamo niente, non si scrive niente. */
    var sappiamo = Array.isArray(p.varianti) && p.varianti.length > 0;
    var da = sappiamo ? p.varianti.filter(function (v) { return v.disponibile; }) : [];
    var prezzo = da.length ? da[0].prezzo : p.prezzoDa;
    corpo.appendChild(elemento("span", "signal-p-prezzo", formattaPrezzo(prezzo, p.valuta)));
    if (sappiamo && !da.length) corpo.appendChild(elemento("span", "signal-p-nota", "Esaurito"));
    else if (da.length && p.tagliaChiestaNonDisponibile) corpo.appendChild(elemento("span", "signal-p-nota", "Non nella tua taglia"));
    c.appendChild(corpo);
    return c;
  }

  /* «100,80 EUR» non e' un prezzo, e' un dato grezzo. */
  function formattaPrezzo(n, valuta) {
    try {
      return new Intl.NumberFormat("it-IT", { style: "currency", currency: valuta || "EUR" }).format(Number(n));
    } catch (e) { return String(n) + " " + (valuta || ""); }
  }


  /* ── la conversazione ────────────────────────────────────────────────────── */

  function chiedi(testo, giaRiprovato) {
    // Toccato un suggerimento, gli altri non servono piu'.
    var chips = nodi.lista.querySelector(".signal-w-chips");
    if (chips) chips.remove();

    testo = String(testo || "").trim();
    if (!testo || stato.occupato) return;
    if (!stato.gettone) { scrivi("assistente", "L'assistente non è disponibile adesso."); return; }
    stato.occupato = true;
    if (!giaRiprovato) { nodi.campo.value = ""; stato.rigaDomanda = scrivi("visitatore", testo); }
    var attesa = puntiniCheAspettano();

    fetch(base() + "/chat?shop=" + encodeURIComponent(stato.negozio), {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Signal-Gettone": stato.gettone },
      body: JSON.stringify({ domanda: testo, prodotto: stato.prodotto ? Number(stato.prodotto) : null }),
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { stato: r.status, j: j }; });
    })
      .then(function (e) {
        stato.occupato = false;
        attesa.remove();
        /* GETTONE SCADUTO: se ne prende un altro e si riprova UNA volta sola. Prima il
           visitatore riceveva «sessione non valida» e restava lì, senza modo di riprendere
           se non ricaricando la pagina. Una volta: due sarebbero un ciclo. */
        if (e.stato === 401 && !giaRiprovato) {
          scordaGettone(stato.negozio);
          stato.gettone = null;
          prendiGettone(stato.negozio).then(function (ok) {
            if (ok) chiedi(testo, true);
            else scrivi("assistente", "Adesso non riesco a risponderti.");
          });
          return;
        }
        var j = e.j;
        if (!j) { scrivi("assistente", "Adesso non riesco a risponderti."); return; }
        if (!j.ok) { scrivi("assistente", j.motivo || "Adesso non riesco a risponderti."); return; }
        scrivi("assistente", j.testo);
        if (j.prodotti && j.prodotti.length) {
          var box = elemento("div", "signal-p-lista");
          j.prodotti.forEach(function (p) { box.appendChild(scheda(p)); });
          nodi.lista.appendChild(box);
        }
        /* LE IDEE DI LOOK. Ogni idea e' un'etichetta e una griglia, come nella
           reference: LOOK 1, LOOK 2, LOOK 3. Il capo che sta guardando e' sempre il
           primo della griglia — il look parte da dove si trova il visitatore. */
        if (j.look && j.look.length) {
          j.look.forEach(function (l) {
            var testa = elemento("div", "signal-l-testa");
            /* La parola la decide il negozio: «LOOK 1» o «PROPOSTA 1».
               Un GRUPPO fatto a mano non e' numerato (numero 0): si chiama col suo nome,
               e «LOOK DI PRIMAVERA 0» non lo deve leggere nessuno. */
            var capo = String(l.etichetta || "Look").toUpperCase();
            testa.appendChild(elemento("span", "signal-l-n", l.numero ? capo + " " + l.numero : capo));
            // Il titolo non si ripete quando e' gia' l'etichetta: succede coi gruppi.
            if (l.titolo && String(l.titolo).toUpperCase() !== capo) testa.appendChild(elemento("span", "signal-l-t", l.titolo));
            nodi.lista.appendChild(testa);
            if (l.perche) nodi.lista.appendChild(elemento("p", "signal-l-p", l.perche));
            var g = elemento("div", "signal-p-lista");
            (l.prodotti || []).forEach(function (p) { g.appendChild(scheda(p)); });
            nodi.lista.appendChild(g);
          });
        }
        contrassegnaCarrello();
        portaInAlto(stato.rigaDomanda);
      })
      .catch(function () {
        stato.occupato = false;
        attesa.remove();
        scrivi("assistente", "Adesso non riesco a risponderti.");
      });
  }

  /* ── avvio ───────────────────────────────────────────────────────────────── */

  /** Riscrive il testo dei blocchi «Idee di look» col nome scelto nel pannello. */
  function allineaInviti(testo) {
    /* SI PARTE DA `.signal-invito`, NON DA `[data-signal-apri]`.
       I due modi di installare mettono quell'attributo in due posti diversi, ed entrambi
       sono giusti per come sono fatti:
         - a mano: `.signal-invito` E' il pulsante, e il testo e' uno span dentro;
         - extension: `.signal-invito` e' il contenitore, il testo e' un <p> e il pulsante
           gli sta ACCANTO (lo vuole lo schema del blocco, con le sue impostazioni).
       Con `[data-signal-apri] .signal-invito-t` — un discendente — sull'extension non si
       trovava niente: l'etichetta scelta dal negozio non arrivava mai a quell'invito, e
       restava quella scritta nel tema. Partendo dal contenitore si coprono entrambe le
       forme senza toccare nessuna delle due: non si decide un disegno nuovo, si fa arrivare
       la parola dove doveva arrivare. */
    var inviti = document.querySelectorAll(".signal-invito .signal-invito-t");
    for (var i = 0; i < inviti.length; i++) inviti[i].textContent = testo;
  }

  function prendiGettone(negozio, salvato) {
    var q = "/avvio?shop=" + encodeURIComponent(negozio);
    // Il capo che ha davanti: cosi' il riquadro si apre gia' su quello, non a vuoto.
    if (stato.prodotto) q += "&prodotto=" + encodeURIComponent(stato.prodotto);
    return fetch(base() + q, { credentials: "omit" })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (j) {
        if (!j || !j.ok || !j.attivo) return false;
        // Il gettone di prima vince su quello nuovo: e' il filo della conversazione.
        var t = (salvato && salvato.t) || j.gettone;
        if (!t) return false;
        stato.gettone = t;
        stato.nome = j.nome || "Assistente";
        stato.saluto = j.saluto || null;
        stato.suggerimenti = j.suggerimenti || [];
        stato.corrente = j.corrente || null;
        stato.avviso = j.avviso || null;
        stato.avvisoPiu = j.avvisoPiu || null;
        /* LA PAROLA LA DECIDE SIGNAL, ANCHE NEL TEMA. Il blocco in linea sulla scheda
           prodotto e' scritto in Liquid, e Liquid viene eseguito da Shopify prima che
           esista una risposta di SIGNAL: quel testo non puo' che essere un ripiego.
           Appena la configurazione arriva, lo si riallinea — altrimenti si finisce con
           due posti che dicono due parole diverse per la stessa cosa, e chi la cambia
           in SIGNAL vede mezzo sito che non gli da' retta. */
        stato.apertura = j.apertura === "modale" ? "modale" : "chat";
        stato.riferimento = j.riferimento || null;
        if (j.chipIdee) allineaInviti(j.chipIdee);
        salvaGettone(negozio, t, stato.nome);
        if (nodi.titolo) nodi.titolo.textContent = stato.nome;
        return true;
      })
      .catch(function () { return false; });
  }

  function avvia() {
    // Idempotente: si può richiamare quante volte si vuole. L'editor del tema ricarica le
    // sezioni senza ricaricare la pagina, e questo file viene eseguito di nuovo.
    if (avvioInCorso || giaCostruito()) return;
    var cfg = trovaConfig();
    if (!cfg || !cfg.dominio || !cfg.negozio) return;
    avvioInCorso = true;
    stato.dominio = cfg.dominio; stato.negozio = cfg.negozio;
    stato.radice = cfg.radice; stato.prodotto = cfg.prodotto;

    /* SI CHIEDE SEMPRE L'APERTURA AL SERVER, anche quando c'e' gia' un gettone salvato.
       Prima, se il visitatore era gia' passato di qui, si saltava la chiamata e si
       disegnava il riquadro con quello che c'era in memoria: nome e gettone. Ma saluto,
       suggerimenti e capo che sta guardando NON stanno in memoria — stanno nella
       risposta del server, e dipendono dalla PAGINA in cui si trova adesso.
       Risultato: a chi tornava, il riquadro si apriva vuoto. E' quello che e' successo
       su Ele Collection: funzionava alla prima visita e si svuotava dalla seconda.
       Il gettone salvato serve a un'altra cosa — non perdere la conversazione di prima —
       e quella continua a valere: si tiene il salvato, si prende il resto dal server. */
    var salvato = gettoneSalvato(cfg.negozio);
    prendiGettone(cfg.negozio, salvato).then(function (ok) {
      avvioInCorso = false;
      // Assistente non configurato o non ammesso: NON si disegna niente. Meglio niente
      // che un riquadro che si apre e non sa rispondere.
      if (ok && !giaCostruito()) costruisci(cfg);
      else if (!ok && salvato && !giaCostruito()) {
        /* Il server non ha risposto ma un gettone ce l'abbiamo: si disegna lo stesso,
           senza saluto. Chi vuole scrivere puo' scrivere; un riquadro che sparisce per
           un inciampo di rete e' peggio di un riquadro un po' spoglio. */
        stato.gettone = salvato.t;
        stato.nome = salvato.nome || stato.nome;
        stato.aperturaFatta = true;
        costruisci(cfg);
      }
    });
  }

  // L'editor del tema: quando si aggiunge, si toglie o si ricarica un blocco, la pagina
  // non si ricarica. Senza questi agganci il riquadro spariva e non tornava.
  document.addEventListener("shopify:section:load", avvia);
  document.addEventListener("shopify:block:select", avvia);
  document.addEventListener("shopify:section:unload", function () {
    if (!trovaConfig() && nodi.root) { nodi.root.remove(); nodi = {}; }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", avvia);
  else avvia();
})();
